import React from 'react';

import { SVGComponentProps } from './svg.types';

const CheckCircleSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <path
          d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z"
          fill={fill}
        />
        <path
          d="M6.40565 13.0918L3.42879 10.1141C3.29224 9.9777 3.18391 9.8157 3.11 9.6373C3.03609 9.459 2.99805 9.2679 2.99805 9.0748C2.99805 8.8818 3.03609 8.6906 3.11 8.5123C3.18391 8.334 3.29224 8.172 3.42879 8.0355C3.70457 7.7602 4.07836 7.6055 4.46808 7.6055C4.8578 7.6055 5.23159 7.7602 5.50737 8.0355L7.3717 9.8981C7.4092 9.9355 7.4601 9.9565 7.5131 9.9565C7.5661 9.9565 7.6169 9.9355 7.6545 9.8981L12.4888 5.06383C12.7646 4.78846 13.1384 4.63379 13.5281 4.63379C13.9178 4.63379 14.2916 4.78846 14.5674 5.06383C14.7039 5.20027 14.8123 5.36228 14.8862 5.5406C14.9601 5.71893 14.9981 5.91008 14.9981 6.10311C14.9981 6.29615 14.9601 6.48729 14.8862 6.66562C14.8123 6.84395 14.7039 7.006 14.5674 7.1424L8.6188 13.0918C8.3253 13.3853 7.9272 13.5501 7.5122 13.5501C7.0972 13.5501 6.69916 13.3853 6.40565 13.0918Z"
          fill="white"
        />
      </svg>
    </span>
  );
};

export default CheckCircleSVG;
